import { updateConsultRequestFields, updateQualificationResponses } from '../../services/customFieldService';
import { t } from '../../utils/i18n';
import {
    appUrl,
    form,
    leadTextId,
    listDataQuestion,
    listNamePageQuestion,
    nameScreenDynamic,
    progressQuestion,
    setListDataQuestion,
    setListNamePageQuestion,
    setNameScreenDynamic,
    setProgressQuestion,
    questionnaireFields,
    questionnaireFormId,
    clearQuestionnaireContext,
} from '../../utils/variables';
import { toastError } from '../../views/components/error';
import { clearCustomFields, loadCustomFields } from '../actions/consultActions';
import { checkboxQuestionListener } from './checkboxQuestionListener';
import { heightQuestionListener } from './heightQuestionListener';
import { customFeildGoBackAnimationHandler } from './movePages';
import { numberQuestionListener } from './numberQuestionListener';
import { selectQuestionListener } from './selectQuestionListener';
import { textAreaQuestonListener } from './textareaQuestionListener';
import { textQuestionListener } from './textQuestionListener';
import { navigateToNextPage } from './navigationHelper';

export function dateQuestionListener() {
    let datepicker = flatpickr(
        `${nameScreenDynamic} #questionDatepicker--${nameScreenDynamic.replace(
            '.',
            ''
        )}`,
        {
            maxDate: 'today',
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'M d, Y',
        }
    );

    // check has data
    if (
        listNamePageQuestion.find((name) => name === nameScreenDynamic) &&
        listDataQuestion[nameScreenDynamic.split('--')[1]]
    ) {
        const value = document.querySelector(
            `${nameScreenDynamic} #questionDatepicker--${nameScreenDynamic.replace(
                '.',
                ''
            )}`
        );
        if (value) {
            value.value = listDataQuestion[nameScreenDynamic.split('--')[1]];
        }
        setTimeout(() => {
            const dateQuestionInput = document.querySelector(
                `${nameScreenDynamic} .dateQuestion--input.form-control.input`
            );
            if (dateQuestionInput !== document.activeElement) {
                dateQuestionInput.focus();
            }
        }, 500);
        document
            .querySelector(`${nameScreenDynamic} .dateQuestionContinue__btn`)
            ?.classList.remove('disabled');
        document
            .querySelector(
                `${nameScreenDynamic} .dateQuestionContinue__btn .loading__wrapper`
            )
            ?.classList.add('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<i class="ri-arrow-right-line"></i>`
            );
        }
        return;
    }

    document
        .querySelector(
            `${nameScreenDynamic} #questionDatepicker--${nameScreenDynamic.replace(
                '.',
                ''
            )}`
        )
        .addEventListener('change', function () {
            if (
                document.querySelector(
                    `${nameScreenDynamic} #questionDatepicker--${nameScreenDynamic.replace(
                        '.',
                        ''
                    )}`
                ).value
            ) {
                document
                    .querySelector(
                        `${nameScreenDynamic} .dateQuestionContinue__btn`
                    )
                    .classList.remove('disabled');
            } else {
                document
                    .querySelector(
                        `${nameScreenDynamic} .dateQuestionContinue__btn`
                    )
                    .classList.add('disabled');
            }
        });

    /* On click Back button */
    document
        .querySelector(`${nameScreenDynamic} .dateQuestionBack__btn`)
        ?.addEventListener('click', handleClickBackDateQuestion);

    /* On click enter */
    const screenDate = document.querySelector(
        `${nameScreenDynamic} .screen--date`
    );

    if (screenDate) {
        screenDate.addEventListener('keydown', (event) => {
            if (
                event.key === 'Enter' &&
                !document
                    .querySelector(
                        `${nameScreenDynamic} .dateQuestionContinue__btn`
                    )
                    .classList.contains('disabled')
            ) {
                document.querySelector(`${nameScreenDynamic} .dateQuestionContinue__btn`).click();
            }
        });
    }

    /* on click Continue after select date */
    document
        .querySelector(`${nameScreenDynamic} .dateQuestionContinue__btn`)
        .addEventListener('click', async () => {
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic)
            ) {
                listNamePageQuestion.push(nameScreenDynamic);
            }
            setListNamePageQuestion(listNamePageQuestion);
            document
                .querySelector(
                    `${nameScreenDynamic} .dateQuestionContinue__btn`
                )
                .classList.add('disabled');
            document
                .querySelector(
                    `${nameScreenDynamic} .dateQuestionContinue__btn .loading__wrapper`
                )
                ?.classList.remove('hidden');
            const loaderIcon = document.querySelector(
                `${nameScreenDynamic} .loader__icon`
            );
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML(
                    'beforeend',
                    `<img src="${appUrl}/assets/icons/rolling.png" />`
                );
            }
            const item = nameScreenDynamic.split('--')[1];
            listDataQuestion[item] = document.querySelector(
                `${nameScreenDynamic} #questionDatepicker--${nameScreenDynamic.replace(
                    '.',
                    ''
                )}`
            ).value;
            setListDataQuestion(listDataQuestion);
            const fields = questionnaireFields?.length
                ? questionnaireFields
                : form?.form?.custom_fields ?? [];
            const formId = questionnaireFormId ?? form?.form?.id;
            let idx = fields.findIndex(
                (custom) => custom && custom.id == nameScreenDynamic.split('--')[1]
            );
            if (idx == fields.length - 1) {
                try {
                    const fieldLabels = {};
                    const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                    sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || t('custom_field')); });
                    if (typeof formId === 'string' && formId.startsWith('ac-')) {
                        const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                        await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                    } else {
                        await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                    }
                    document
                        .querySelector(
                            `${nameScreenDynamic} .dateQuestionContinue__btn`
                        )
                        ?.classList.remove('disabled');
                    document
                        .querySelector(
                            `${nameScreenDynamic} .dateQuestionContinue__btn .loading__wrapper`
                        )
                        ?.classList.remove('hidden');
                    const valueDate = document.querySelector(
                        `${nameScreenDynamic} #questionDatepicker--${nameScreenDynamic}`
                    );
                    if (valueDate) {
                        valueDate.value = '';
                    }
                    const loaderIcon = document.querySelector(
                        `${nameScreenDynamic} .loader__icon`
                    );
                    if (loaderIcon) {
                        loaderIcon.innerHTML = '';
                        loaderIcon.insertAdjacentHTML(
                            'beforeend',
                            `<i class="ri-arrow-right-line"></i>`
                        );
                    }
                    clearCustomFields();
                    clearQuestionnaireContext();
                    navigateToNextPage();

                } catch (error) {
                    toastError(error.response?.data?.message);
                }
            } else {
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion + 1,
                    progress: (((progressQuestion.currentQuestion + 1) / progressQuestion.total) * 100)
                });
                loadCustomFields(fields[idx + 1]);
            }
        });
}

function handleClickBackDateQuestion() {
    const idx = listNamePageQuestion.findIndex(
        (l) => l === nameScreenDynamic
    );
    if (idx > 0) {
        customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
        setProgressQuestion({
            ...progressQuestion,
            currentQuestion: progressQuestion.currentQuestion - 1,
            progress: (((progressQuestion.currentQuestion - 1) / progressQuestion.total) * 100)
        });
        setNameScreenDynamic(listNamePageQuestion[idx - 1]);

        if (
            nameScreenDynamic.includes('text') &&
            !nameScreenDynamic.includes('textarea')
        ) {
            textQuestionListener();
        } else if (nameScreenDynamic.includes('checkbox')) {
            checkboxQuestionListener();
        } else if (nameScreenDynamic.includes('select')) {
            selectQuestionListener();
        } else if (nameScreenDynamic.includes('date')) {
            dateQuestionListener();
        } else if (nameScreenDynamic.includes('textarea')) {
            textAreaQuestonListener();
        } else if (nameScreenDynamic.includes('number')) {
            numberQuestionListener();
        } else if (nameScreenDynamic.includes('height')) {
            heightQuestionListener();
        }
    } else {
        customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
    }
}